import React from 'react';
import { ColorPreview } from 'components/field-color';

export const GridFieldColorTemplate: React.FC<React.PropsWithChildren<{ value: string }>> = ({ value }) => {
  return <ColorPreview value={value} />;
};
